export default {"src":"/_next/static/media/boat-icon.a6d62342.svg","height":46,"width":24,"blurWidth":0,"blurHeight":0};